module.exports = __webpack_public_path__ + "img/taili8.71886bc2.jpg";